// extracted by mini-css-extract-plugin
module.exports = {"main":"PageHeader_main__xix2W","publicationDate":"PageHeader_publicationDate__xucPI"};